import { render } from "./submitChallenge.vue?vue&type=template&id=166c4703"
import script from "./submitChallenge.vue?vue&type=script&lang=js"
export * from "./submitChallenge.vue?vue&type=script&lang=js"

import exportComponent from "/Users/benjamin/Documents/GitHub/beatmania-app-structure/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__